import {$controller} from "rapid/index";

export class TwoFactorController extends $controller {
    constructor($injector, $state, $auth, $timeout) {
        "ngInject";
        super($injector, []);
        this.$state = $state;
        this.$auth = $auth;
        this.$timeout = $timeout;
        this.otpArr = ["", "", "", "", "", ""];
        this.email = sessionStorage.getItem("2fa_email");
        this.password = sessionStorage.getItem("2fa_password");
        this.resendDisabled = false;
        this.resendMessage = "";
    }

    onKeyUp(event, idx) {
        const input = event.target;
        const value = input.value;

        // Only allow numbers
        if (!/^[0-9]$/.test(value) && value !== "") {
            this.otpArr[idx] = "";
            return;
        }

        // Move to next input if not last and value entered
        if (value && idx < 5) {
            const next = input.parentElement.querySelectorAll("input")[idx + 1];
            if (next) next.focus();
        }
        // Replace value in last input
        if (idx === 5 && value.length > 1) {
            this.otpArr[5] = value.slice(-1);
        }
    }

    onPaste(event) {
        event.preventDefault();
        const paste = (event.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "");
        for (let i = 0; i < 6; i++) {
            this.otpArr[i] = paste[i] || "";
        }
        // Фокус на перший незаповнений
        this.$timeout(() => {
            const inputs = event.target.parentElement.querySelectorAll("input");
            for (let i = 0; i < 6; i++) {
                if (!this.otpArr[i]) {
                    inputs[i].focus();
                    break;
                }
            }
        });
    }

    $onSubmit() {
        const otp = this.otpArr.join("");
        if (otp.length !== 6) return;
        this.$auth.authenticate({
            email: this.email,
            password: this.password,
            token: otp
        },true).then((data) => {
            sessionStorage.removeItem("2fa_email");
            sessionStorage.removeItem("2fa_password");
            this.$auth.finalizeLogin(data)
                .then(() => {
                this.$state.go("auth.twoFactorSuccess");
            })
                .catch((err) => {
                console.error("finalizeLogin error", err);
            });
        });
    }

    resendCode() {
        if (this.resendDisabled) return;
        this.resendDisabled = true;
        this.resendMessage = "";

        this.$auth.authenticate({
            email: this.email,
            password: this.password
        }).then((data) => {
            if (data && data.requires_2fa) {
                this.resendMessage = "Verification code sent!";
            } else {
                this.resendMessage = "Unexpected response!";
            }
        }).catch(() => {
            this.resendMessage = "Failed to resend code!";
        }).finally(() => {
            this.$timeout(() => {
                this.resendDisabled = false;
                this.resendMessage = "";
            }, 10000);
        });
    }
} 



// WEBPACK FOOTER //
// ./sources/components/auth/two-factor/two-factor.controller.js